import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { personnel, PersonnelManipulationViewModel } from "./personnelManipulation-viewModel"

export class PersonnelManipulationView extends View<PersonnelManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-814EA7DE-8452-47B6-8E28-F80A7B6FF563"
    }
    loadHtml(): string {
        let element = require('./personnelManipulation.html').default;
        let style = require('./personnelManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    public set personnel(v: ObservableArray<personnel>) { this._personnel = v; } public get personnel(): ObservableArray<personnel> { return this._personnel;} private _personnel: ObservableArray<personnel>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    addNew(){
        this.dataContext.addNew();
    }

}
